import { render, staticRenderFns } from "./EmployeeRegistration.vue?vue&type=template&id=303b8ee4&scoped=true&"
import script from "./EmployeeRegistration.vue?vue&type=script&lang=ts&"
export * from "./EmployeeRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeRegistration.vue?vue&type=style&index=0&id=303b8ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303b8ee4",
  null
  
)

component.options.__file = "EmployeeRegistration.vue"
export default component.exports